import {
  createStylesParams,
  StyleParamType,
  wixColorParam,
  wixFontParam,
} from '@wix/tpa-settings';

import { tpaColorName } from '../../../../../utils/color';

export type DesignStylesParams = {
  titleColor: StyleParamType.Color;
  titleFont: StyleParamType.Font;
  statusColor: StyleParamType.Color;
  statusFont: StyleParamType.Font;
  subtitleColor: StyleParamType.Color;
  subtitleFont: StyleParamType.Font;
  sectionLabelColor: StyleParamType.Color;
  sectionLabelFont: StyleParamType.Font;
  bodyColor: StyleParamType.Color;
  bodyFont: StyleParamType.Font;

  backgroundColor: StyleParamType.Color;
  backgroundBorderWidth: StyleParamType.Number;
  backgroundBorderColor: StyleParamType.Color;
  backgroundCornerRadiusTopLeft: StyleParamType.Number;
  backgroundCornerRadiusTopRight: StyleParamType.Number;
  backgroundCornerRadiusBottomLeft: StyleParamType.Number;
  backgroundCornerRadiusBottomRight: StyleParamType.Number;
  backgroundCornerRadiusLinked: StyleParamType.Number;
  dividerWidth: StyleParamType.Number;
  dividerColor: StyleParamType.Color;
};

export const designStylesParams = createStylesParams<DesignStylesParams>({
  titleColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam(tpaColorName('wst-heading-2-color'), 1),
  },
  titleFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Heading-M', { htmlTag: 'h1', size: 28 }),
  },
  statusColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam(tpaColorName('wst-paragraph-2-color'), 1),
  },
  statusFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', { htmlTag: 'p', size: 16 }),
  },
  subtitleColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam(tpaColorName('wst-heading-2-color'), 1),
  },
  subtitleFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Heading-M', { htmlTag: 'h2', size: 24 }),
  },
  sectionLabelColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam(tpaColorName('wst-paragraph-2-color'), 1),
  },
  sectionLabelFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', { htmlTag: 'h3', size: 18 }),
  },
  bodyColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam(tpaColorName('wst-paragraph-2-color'), 1),
  },
  bodyFont: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', { htmlTag: 'p', size: 14 }),
  },
  backgroundColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam(
      tpaColorName('wst-primary-background-color'),
      1,
    ),
  },
  backgroundBorderWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  backgroundBorderColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam(tpaColorName('wst-paragraph-2-color'), 0.12),
  },
  backgroundCornerRadiusTopLeft: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  backgroundCornerRadiusTopRight: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  backgroundCornerRadiusBottomLeft: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  backgroundCornerRadiusBottomRight: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  backgroundCornerRadiusLinked: {
    type: StyleParamType.Number,
    getDefaultValue: () => 0,
  },
  dividerWidth: {
    type: StyleParamType.Number,
    getDefaultValue: () => 1,
  },
  dividerColor: {
    type: StyleParamType.Color,
    getDefaultValue: wixColorParam(tpaColorName('wst-paragraph-2-color'), 0.12),
  },
});
